let activeStep = 0;
const steps = document.querySelectorAll(".bundleBuilderStep");

const bundleSelections = {
    size: 3,
    items: [],
}

const bundleDiscounts = {
    2: 0.15, // 2 Items 15% Off
    3: 0.25, // 3 Items 25% Off
    4: 0.35, // 4 Items 35% Off
}

const bundleBuilderTranslations = {
    "Add To Box": "Setja í pakka",
}

// Get the price of a product with the bundle discount
const priceWithBundleDiscount = (amountInCents, removeTrailingZeros = false) => {
    // calculate total with discount
    let total = ((amountInCents - (bundleDiscounts[bundleSelections.size] * amountInCents)) / 100);

    // Get the decimal part by subtracting the integer part
    const decimal = total - Math.floor(total);

    // Check if the decimal part is less than or greater than 0.50
    if (decimal < 0.50) {
        // If less than 0.50, round down
        total = Math.floor(total);
    } else {
        // If 0.50 or more, round up
        total = Math.ceil(total);
    }

    total = total.toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total with currency
    return shopCurrency === "ISK" ? `${total} ${currency}` : `${currency}${total}`;
}

/***** Bundle Builder Navigation *****/

function updateBundleBuilderNavigation() {
    const bundlerBuilderNavigationSteps = document.querySelectorAll(".bundleBuilderNavStepItemsButton");

    // Remove all classes
    bundlerBuilderNavigationSteps.forEach((step) => {
        step.classList.remove("active");
        step.classList.remove("complete");
    });

    // Mark complete all previous steps
    for (let i = 0; i < activeStep; i++) {
        bundlerBuilderNavigationSteps[i].classList.add("complete");
    }

    // Mark active current step
    bundlerBuilderNavigationSteps[activeStep].classList.add("active");
}


function getBundlePercent() {
    console.log( Math.round((bundleDiscounts[bundleSelections.size] || 0) * 100))
  return Math.round((bundleDiscounts[bundleSelections.size] || 0) * 100);
}

function renderBadgeForItem(item) {
  const badge = item.querySelector(".bbBadge--discount");
  const mobileBadge = item.querySelector(".bbBadgeMobile--discount");
  if (!badge || !mobileBadge) return;

  const productDiscount = Number(item.dataset.productDiscount || 0);
  const bundlePercent = getBundlePercent();

  if (productDiscount > 0 && bundlePercent > 0) {
    badge.innerHTML = `${productDiscount}% svo ${bundlePercent}%`;
    badge.hidden = false;
    mobileBadge.innerHTML = `${productDiscount}% svo ${bundlePercent}%`;
    mobileBadge.hidden = false;
  } else if (bundlePercent > 0) {
    badge.textContent = `${bundlePercent}% afsláttur`;
    badge.hidden = false;
    mobileBadge.innerHTML = `${bundlePercent}%`;
    mobileBadge.hidden = false;
  } else if (productDiscount > 0) {
    badge.textContent = `${productDiscount}% afsláttur`;
    badge.hidden = false;
    mobileBadge.innerHTML = `${productDiscount}%`;
    mobileBadge.hidden = false;
  } else {
    badge.hidden = true;
    mobileBadge.hidden = true;
  }
}

function renderAllBadges() {
  document.querySelectorAll(".bundleBuilderStepItemsGridItem").forEach(renderBadgeForItem);
}

// Click event listener for each navigation step
document.querySelectorAll(".bundleBuilderNavStepItemsButton").forEach((button, index) => {
    button.addEventListener("click", () => {
        // Advance only if the step is already completed
        if (index > activeStep) return;

        // Hide current step
        steps[activeStep]?.classList.remove("active");

        // Show clicked step
        steps[index]?.classList.add("active");

        // Update active step
        activeStep = index;

        // Update navigation
        updateBundleBuilderNavigation();

        // Update discount badges
        renderAllBadges();
    });
});

/***** Size Step Pack Option Buttons *****/

document.querySelectorAll(".bundleBuilderStepSizeOptionsButton").forEach((button) => {
    // Add click event listener to each button
    button.addEventListener("click", () => {
        // Remove active class from all buttons
        document.querySelectorAll(".bundleBuilderStepSizeOptionsButton").forEach((button) => {
            button.classList.remove("active");
        });

        // Add active class to clicked button
        button.classList.add("active");

        // Update bundleSelections size
        bundleSelections.size = parseInt(button.dataset.size);

        // Clear all selections
        bundleSelections.items = [];

        // Reset all quantity inputs
        document.querySelectorAll(".bundleBuilderStepItemsGridItemQuantity").forEach(quantityEl => {
            quantityEl.querySelector("input").value = 0;

            // dispatch change event to trigger input event listener
            quantityEl.querySelector("input").dispatchEvent(new Event("change"));

            quantityEl.classList.remove("active");
        });

        // Show all add to cart buttons
        document.querySelectorAll(".bundleBuilderStepItemsGridItemATC").forEach(button => {
            button.classList.remove("hidden");
            button.textContent = "Setja í pakka";
            button.disabled = false;
        });

        // Update bundle prices
        document.querySelectorAll(".bundleBuilderStepItemsGridItem").forEach(item => {
            const productInfo = bundleProducts.find(product => product.id === parseInt(item.dataset.productId));
            item.querySelector(".bundleBuilderStepItemsGridItemPriceReal").textContent = priceWithBundleDiscount(productInfo.variants[0].price, true);
        });

        // update variant menu option prices
        document.querySelectorAll(".bundleBuilderStepItemsGridItemVariantSelectMenuOption").forEach(option => {
            const priceList = JSON.parse(option.dataset.prices);

            // find price list for bundle size
            const bundleSizePriceList = priceList[bundleSelections.size];

            // set price
            option.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionPriceReal").textContent = bundleSizePriceList[0];

            // set compare price
            option.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionPriceCompare").textContent = bundleSizePriceList[1];
        });

        // Dispatch change on variant selects
        document.querySelectorAll(".bundleBuilderStepItemsGridItemVariantSelect").forEach(select => select.dispatchEvent(new Event("change")));
    });
});

/***** Size Step Next Button *****/

document.querySelector("#bundleBuilderStepSizeNextStepButton").addEventListener("click", () => {
    // Hide current step
    steps[activeStep].classList.remove("active");

    // Update active step
    activeStep++;

    // Show next step
    steps[activeStep]?.classList.add("active");

    // Update navigation
    updateBundleBuilderNavigation();

    // Update bundle cart
    updateBundleCart();
});

/***** Bundle Items *****/

document.querySelectorAll(".bundleBuilderStepItemsGridItem").forEach(item => {
    const variantSelect = item.querySelector(".bundleBuilderStepItemsGridItemVariantSelect");

    /***** Variant Select Change Listener *****/

    variantSelect?.addEventListener("change", () => {
        // Find product in bundleProducts
        const bundleProduct = bundleProducts.find(product => product.id === parseInt(item.dataset.productId));
        const bundleVariant = bundleProduct.variants.find(variant => variant.id === parseInt(variantSelect.dataset.value));

        const selectedOption = item.querySelector(
            `.bundleBuilderStepItemsGridItemVariantSelectMenuOption[data-value="${variantSelect.dataset.value}"]`
        );

        const pd = Number(selectedOption?.dataset?.discount || 0);
        item.dataset.productDiscount = pd;
        renderBadgeForItem(item);

        // Update Image

        /* 
            if (bundleVariant.featured_image) {
                item.querySelector(".bundleBuilderStepItemsGridItemImg").src = bundleVariant.featured_image.src;
            }
        */

        // Update Real Price
        item.querySelector(".bundleBuilderStepItemsGridItemPriceReal").textContent = `${priceWithBundleDiscount(bundleVariant.price, true)}`;

        // Update Compare at Price
        item.querySelector(".bundleBuilderStepItemsGridItemPriceCompare").textContent = `${price(bundleVariant.price, true)}`;

        // is it an existing selection
        const existingSelection = bundleSelections.items.find(selection => selection.item.id === parseInt(variantSelect.dataset.value));

        // check availability
        if (!bundleVariant.available) {
            item.querySelector(".bundleBuilderStepItemsGridItemATC").textContent = "Uppselt";
            item.querySelector(".bundleBuilderStepItemsGridItemATC").setAttribute("disabled", "");
        } else {
            item.querySelector(".bundleBuilderStepItemsGridItemATC").textContent = bundleBuilderTranslations["Add To Box"];
            item.querySelector(".bundleBuilderStepItemsGridItemATC").removeAttribute("disabled");
        }

        if (existingSelection) {
            // show quantity
            item.querySelector(".bundleBuilderStepItemsGridItemQuantity").classList.add("active");

            // set quantity
            item.querySelector(".bundleBuilderStepItemsGridItemQuantityInput").value = existingSelection.quantity;

            // hide add to cart button
            item.querySelector(".bundleBuilderStepItemsGridItemATC").classList.add("hidden");
        } else {
            // Reset Quantity
            item.querySelector(".bundleBuilderStepItemsGridItemQuantityInput").value = 0;

            // Hide Quantity
            item.querySelector(".bundleBuilderStepItemsGridItemQuantity").classList.remove("active");

            // Show Button
            item.querySelector(".bundleBuilderStepItemsGridItemATC").classList.remove("hidden");
        }
    });


    /***** Quantity Listener *****/

    // Quantity Decrease
    item.querySelector(".bundleBuilderStepItemsGridItemQuantityButton.minus").addEventListener("click", function (e) {
        const input = item.querySelector(".bundleBuilderStepItemsGridItemQuantityInput");
        const value = parseInt(input.value);

        if (value < 0) {
            input.value = 0;
            return;
        }

        // Set Quantity
        input.value = value - 1;

        // Dispatch change event to trigger input event listener
        input.dispatchEvent(new Event("change"));
    });

    // Quantity Increase
    item.querySelector(".bundleBuilderStepItemsGridItemQuantityButton.plus").addEventListener("click", function (e) {
        const input = item.querySelector(".bundleBuilderStepItemsGridItemQuantityInput");
        const value = parseInt(input.value);

        // Update Quantity
        input.value = value + 1;

        // Dispatch change event to trigger input event listener
        input.dispatchEvent(new Event("change"));
    });

    // Input Quantity
    item.querySelector(".bundleBuilderStepItemsGridItemQuantityInput").addEventListener("change", function (e) {
        const existingSelection = bundleSelections.items.find(selection => selection.item.id === parseInt(variantSelect.dataset.value));

        // match to variant select value
        const matchingVariantSelectOption = item.querySelector(`.bundleBuilderStepItemsGridItemVariantSelectMenuOption[data-value="${variantSelect.dataset.value}"]`);

        // If quantity is 0 remove from bundleSelections
        if (parseInt(e.target.value) === 0) {
            bundleSelections.items = bundleSelections.items.filter(selection => selection.item.id !== parseInt(variantSelect.dataset.value));

            // Hide Quantity if 0
            item.querySelector(".bundleBuilderStepItemsGridItemQuantity").classList.remove("active");

            // Show ATC Button
            item.querySelector(".bundleBuilderStepItemsGridItemATC").classList.remove("hidden");

            // remove badge
            matchingVariantSelectOption.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionBadge").textContent = "";
        }
        // If already in bundleSelections update quantity
        else if (existingSelection) {
            existingSelection.quantity = parseInt(e.target.value);

            // update badge to selected quantity
            matchingVariantSelectOption.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionBadge").textContent = `${e.target.value} Added`;
        }
        // If not in bundleSelections add to bundleSelections
        else {
            bundleSelections.items.push({
                item: bundleProducts.find(product => product.id === parseInt(item.dataset.productId)).variants.find(variant => variant.id === parseInt(variantSelect.dataset.value)),
                quantity: parseInt(e.target.value)
            });

            // update badge to selected quantity
            matchingVariantSelectOption.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionBadge").textContent = `${e.target.value} Added`;
        }

        // Check if updating quantity would push product to the bundle limit
        if (getTotalSelectionQuantity() + 1 > bundleSelections.size) {
            // disable all quantity plus buttons
            document.querySelectorAll(".bundleBuilderStepItemsGridItemQuantityButton.plus").forEach(button => {
                button.disabled = true;
            });

            // disable all add to cart buttons
            document.querySelectorAll(".bundleBuilderStepItemsGridItemATC").forEach(button => {
                button.textContent = "Your Box is full";
                button.disabled = true;
            });
        } else {
            // enable all quantity plus buttons
            document.querySelectorAll(".bundleBuilderStepItemsGridItemQuantityButton.plus").forEach(button => {
                button.disabled = false;
            });

            // enable all add to cart buttons
            document.querySelectorAll(".bundleBuilderStepItemsGridItemATC").forEach(button => updateAddToBoxButton(button));

        }

        // Update Bundle Cart
        updateBundleCart();
    });

    /***** Add To Box Button *****/

    item.querySelector(".bundleBuilderStepItemsGridItemATC").addEventListener("click", function () {
        // Hide Button
        this.classList.add("hidden");

        // Increase quantity
        item.querySelector(".bundleBuilderStepItemsGridItemQuantityButton.plus").click();

        // Show Quantity
        item.querySelector(".bundleBuilderStepItemsGridItemQuantity").classList.add("active");

        // Set Quantity to 1
        item.querySelector(".bundleBuilderStepItemsGridItemQuantityInput").value = 1;

        // Dispatch change event to trigger input event listener
        item.querySelector(".bundleBuilderStepItemsGridItemQuantityInput").dispatchEvent(new Event("change"));
    });

});

/***** Bundle Cart *****/

// Close Cart on click outside
document.querySelector("#bundleBuilderStepItemsCart").addEventListener("click", (e) => {
    if (e.target === document.querySelector("#bundleBuilderStepItemsCart")) {
        document.querySelector("#bundleBuilderStepItemsCart").classList.remove("open");
    }
});

// Open Cart on header click
document.querySelector("#bundleBuilderStepItemsCartHeader").addEventListener("click", () => {
    // Add open class to cart
    document.querySelector("#bundleBuilderStepItemsCart").classList.add("open");
});

// Upgrade listener
document.querySelector("#bundleBuilderStepItemsCartHeaderUpgrade").addEventListener("click", () => {
    // Increase bundle size
    switch (bundleSelections.size) {
        case 2:
            bundleSelections.size = 3;
            break;
        case 3:
            bundleSelections.size = 4;
            break;
    }

    // Update selected bundle
    document.querySelector(".bundleBuilderStepSizeOptionsButton.active").classList.remove("active");

    // Update bundle size
    document.querySelector(`.bundleBuilderStepSizeOptionsButton[data-size="${bundleSelections.size}"]`).classList.add("active")


    // Re-enable all quantity plus buttons
    document.querySelectorAll(".bundleBuilderStepItemsGridItemQuantityButton.plus").forEach(button => {
        button.disabled = false;
    });

    // Re-enable all add to cart buttons
    document.querySelectorAll(".bundleBuilderStepItemsGridItemATC").forEach(button => updateAddToBoxButton(button));

    // Update bundle prices
    document.querySelectorAll(".bundleBuilderStepItemsGridItem").forEach(item => {
        const productInfo = bundleProducts.find(product => product.id === parseInt(item.dataset.productId));

        // Update bundle prices
        item.querySelector(".bundleBuilderStepItemsGridItemPriceReal").textContent = priceWithBundleDiscount(productInfo.variants[0].price, true);
    });

    // Update variant menu option prices
    document.querySelectorAll(".bundleBuilderStepItemsGridItemVariantSelectMenuOption").forEach(option => {
        const priceList = JSON.parse(option.dataset.prices);

        // find price list for bundle size
        const bundleSizePriceList = priceList[bundleSelections.size];

        // set price
        option.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionPriceReal").textContent = bundleSizePriceList[0];

        // set compare price
        option.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionPriceCompare").textContent = bundleSizePriceList[1];
    });

    // Update bundle cart
    updateBundleCart();
});

// Update Bundle Cart
function updateBundleCart() {
    const totalQuantity = getTotalSelectionQuantity();

    // Toggle empty cart message
    document.querySelector("#bundleBuilderStepItemsCartBodyEmpty").classList.toggle("active", totalQuantity === 0);

    // Update progress bar
    document.querySelector("#bundleBuilderStepItemsCartHeaderProgressBarInner").style.width = `${(totalQuantity / bundleSelections.size) * 100}%`;

    // Update count
    document.querySelector("#bundleBuilderStepItemsCartHeaderProgressCountAmount").textContent = `${totalQuantity}/${bundleSelections.size}`;

    // Upgrade functionality
    switch (bundleSelections.size) {
        case 2:
            document.querySelector("#bundleBuilderStepItemsCartHeaderUpgrade").textContent = "Uppfæra í 3 hluti fyrir 15% off";
            break;
        case 3:
            document.querySelector("#bundleBuilderStepItemsCartHeaderUpgrade").textContent = "Uppfæra í 4 hluti fyrir 20% off";
            break;
        default:
            document.querySelector("#bundleBuilderStepItemsCartHeaderUpgrade").textContent = "";
            break;
    }

    // Update things based on total quantity
    if (totalQuantity === bundleSelections.size) {
        // Header Title
        document.querySelector("#bundleBuilderStepItemsCartHeaderTitle").textContent = "Your box is full. Time to checkout!";

        // Checkout Button
        document.querySelector("#bundleBuilderStepItemsCartBodyCheckoutButton").disabled = false;
        document.querySelector("#bundleBuilderStepItemsCartBodyCheckoutButton").textContent = "Greiða";

        // Show cart once full
        document.querySelector("#bundleBuilderStepItemsCart").classList.add("open");
    } else {
        // Header Title
        document.querySelector("#bundleBuilderStepItemsCartHeaderTitle").textContent = "Búðu til þinn fullkomna pakka";

        // Checkout Button
        document.querySelector("#bundleBuilderStepItemsCartBodyCheckoutButton").disabled = true;
        document.querySelector("#bundleBuilderStepItemsCartBodyCheckoutButton").textContent = "Add More Items";
    }

    // Append items to cart
    const cartItemHTML = (item) => {
        const quantity = bundleSelections.items.find(selection => selection.item.id === item.id).quantity;

        return `
            <div data-id="${item.id}" class="bundleBuilderStepItemsCartBodyItem">
                <img class="bundleBuilderStepItemsCartBodyItemImg" src="${item.featured_image.src}" alt="${item.featured_image.alt}">
                <div class="bundleBuilderStepItemsCartBodyItemName">
                    ${item.name.replaceAll(/Bundle\b:*/gi, "")}
                </div>
                <div class="bundleBuilderStepItemsCartBodyItemPrice">
                    <div class="bundleBuilderStepItemsCartBodyItemPriceReal">${priceWithBundleDiscount(item.price * quantity, true)}</div>
                    <div class="bundleBuilderStepItemsCartBodyItemPriceCompare diagonal-strike">${price(item.price * quantity, true)}</div>
                </div>
                <div class="bundleBuilderStepItemsCartBodyItemQuantity">
                    <button class="bundleBuilderStepItemsCartBodyItemQuantityButton minus">-</button>
                    <input class="bundleBuilderStepItemsCartBodyItemQuantityInput" type="number" value="${bundleSelections.items.find(selection => selection.item.id === item.id).quantity}" readonly>
                    <button class="bundleBuilderStepItemsCartBodyItemQuantityButton plus">+</button>
                </div>
            </div>
        `
    }

    document.querySelector("#bundleBuilderStepItemsCartBodyItems").innerHTML = bundleSelections.items.map(item => cartItemHTML(item.item)).join("");


    // Check if updating quantity would push product to the bundle limit
    if (getTotalSelectionQuantity() + 1 > bundleSelections.size) {
        // disable all quantity plus buttons
        document.querySelectorAll(".bundleBuilderStepItemsCartBodyItemQuantityButton.plus").forEach(button => {
            button.disabled = true;
        });
    } else {
        // disable all quantity plus buttons
        document.querySelectorAll(".bundleBuilderStepItemsCartBodyItemQuantityButton.plus").forEach(button => {
            button.disabled = false;
        });
    }

    // Quantity listeners
    document.querySelectorAll(".bundleBuilderStepItemsCartBodyItemQuantity").forEach(quantity => {

        // Plus & minus button listeners
        quantity.addEventListener("click", function (e) {
            if (e.target.classList.contains("minus")) {
                const input = this.querySelector("input");
                const value = parseInt(input.value);

                if (value < 0) {
                    input.value = 0;
                    return;
                }

                // Set Quantity
                input.value = value - 1;

                // Dispatch change event to trigger input event listener
                input.dispatchEvent(new Event("change"));
            } else if (e.target.classList.contains("plus")) {
                const input = this.querySelector("input");
                const value = parseInt(input.value);

                // Update Quantity
                input.value = value + 1;

                // Dispatch change event to trigger input event listener
                input.dispatchEvent(new Event("change"));
            }
        });

        // Input listener
        quantity.querySelector("input").addEventListener("change", function (e) {
            const bundleItem = bundleSelections.items.find(selection => selection.item.id === parseInt(this.closest(".bundleBuilderStepItemsCartBodyItem").dataset.id));

            const matchingVariantSelectOption = document.querySelector(`.bundleBuilderStepItemsGridItemVariantSelectMenuOption[data-value="${bundleItem.item.id}"]`);

            const matchingVariantSelect = document.querySelector(`.bundleBuilderStepItemsGridItemVariantSelect[data-value="${bundleItem.item.id}"]`);

            // Update associated quantity input if variant is currently selected
            if (matchingVariantSelect) {
                // Update quantity input
                matchingVariantSelect.closest(".bundleBuilderStepItemsGridItem").querySelector(".bundleBuilderStepItemsGridItemQuantityInput").value = this.value;

                // dispatch change event to trigger input event listener
                matchingVariantSelect.closest(".bundleBuilderStepItemsGridItem").querySelector(".bundleBuilderStepItemsGridItemQuantityInput").dispatchEvent(new Event("change"));

                return;
            }
            // If quantity is 0 remove from bundleSelections
            else if (parseInt(this.value) === 0) {
                bundleSelections.items = bundleSelections.items.filter(selection => selection.item.id !== parseInt(bundleItem.item.id));

                // remove badge
                matchingVariantSelectOption.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionBadge").textContent = "";
            }
            // update quantity
            else {
                // Update quantity
                bundleItem.quantity = parseInt(this.value);

                // update badge to selected quantity
                matchingVariantSelectOption.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionBadge").textContent = `${this.value} Added`;
            }

            // Check if updating quantity would push product to the bundle limit
            if (getTotalSelectionQuantity() + 1 > bundleSelections.size) {
                // disable all quantity plus buttons
                document.querySelectorAll(".bundleBuilderStepItemsGridItemQuantityButton.plus").forEach(button => {
                    button.disabled = true;
                });

                // disable all add to cart buttons
                document.querySelectorAll(".bundleBuilderStepItemsGridItemATC").forEach(button => {
                    button.textContent = "Your Box is full";
                    button.disabled = true;
                });
            } else {
                // enable all quantity plus buttons
                document.querySelectorAll(".bundleBuilderStepItemsGridItemQuantityButton.plus").forEach(button => {
                    button.disabled = false;
                });

                // enable all add to cart buttons
                document.querySelectorAll(".bundleBuilderStepItemsGridItemATC").forEach(button => {
                    button.textContent = "Add to Box";
                    button.disabled = false;
                });
            }

            // Update bundle cart
            updateBundleCart();
        });
    });
}

/***** Checkout *****/

document.querySelector("#bundleBuilderStepItemsCartBodyCheckoutButton").addEventListener("click", async function (e) {
    // loading
    this.classList.add("loading");

    // map products to shopify format
    let formData = {
        items: []
    };

    bundleSelections.items.forEach(selection => {
        formData.items.push({
            id: selection.item.id,
            quantity: selection.quantity
        });
    });

    // clear cart
    await fetch('/cart/clear.js');

    // add to cart
    await addProduct(formData);

    // remove loading
    this.classList.remove("loading");

    // redirect to checkout
    window.location.href = "/checkout";
});

/***** Variant Select Menus *****/

document.querySelectorAll(".bundleBuilderStepItemsGridItemVariantSelect").forEach(select => {
    const options = select.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptions");
    const label = select.querySelector(".bundleBuilderStepItemsGridItemVariantSelectLabel");

    // Select Label Click
    label.addEventListener("click", () => {
        select.classList.toggle("active");
    });

    // Options click
    select.querySelectorAll(".bundleBuilderStepItemsGridItemVariantSelectMenuOption").forEach(option => {
        option.addEventListener("click", () => {
            // Update select label
            select.querySelector(".bundleBuilderStepItemsGridItemVariantSelectLabelText").textContent = option.querySelector(".bundleBuilderStepItemsGridItemVariantSelectMenuOptionText").textContent;

            // Update select value
            select.dataset.value = option.dataset.value;

            // Dispatch change event to trigger change event listener
            select.dispatchEvent(new Event("change"));

            // Close select
            select.classList.remove("active");
        });
    });

    // Close select on outside click
    document.addEventListener("click", (e) => {
        if (!select.contains(e.target) && !options.contains(e.target) && e.target !== label) {
            select.classList.remove("active");
        }
    });
});


/***** Utility *****/

function getTotalSelectionQuantity() {
    return bundleSelections.items.reduce((acc, selection) => acc + selection.quantity, 0);
}

function updateAddToBoxButton(button){
    const item = button.closest(".bundleBuilderStepItemsGridItem");
    const variantSelect = item.querySelector(".bundleBuilderStepItemsGridItemVariantSelect");
    const bundleProduct = bundleProducts.find(product => product.id === parseInt(item.dataset.productId));
    const bundleVariant = bundleProduct.variants.find(variant => variant.id === parseInt(variantSelect.dataset.value));

    button.textContent = bundleVariant.available ? bundleBuilderTranslations["Add To Box"] : "Uppselt";
    button.toggleAttribute("disabled", !bundleVariant.available);
}
